import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { HeroSectionComponent } from './features/home/hero-section/hero-section.component';
import { FeaturesSectionComponent } from './features/home/features-section/features-section.component';
import { HomeComponent } from './features/home/home.component';
import { FeaturesComponent } from './features/features/features.component';
import { PricingComponent } from './features/home/pricing/pricing.component';
import { DemoComponent } from './features/demo/demo.component';
import { BlogComponent } from './features/blog/blog.component';
import { ContactComponent } from './features/contact/contact.component';
import { FooterComponent } from './shared/footer/footer.component';
import { UseCasesComponent } from './features/home/use-cases/use-cases.component';
import { CommonModule } from '@angular/common';
import { PricingModelsComponent } from './features/home/pricing-models/pricing-models.component';
import { KeyBenefitsComponent } from './features/home/key-benefits/key-benefits.component';
import { TestimonialsComponent } from './features/home/testimonials/testimonials.component';
import { FaqComponent } from './features/home/faq/faq.component';
import { CtaComponent } from './features/home/cta/cta.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HeroSectionComponent,
    FeaturesSectionComponent,
    HomeComponent,
    FeaturesComponent,
    PricingComponent,
    DemoComponent,
    BlogComponent,
    ContactComponent,
    FooterComponent,
    UseCasesComponent,
    PricingModelsComponent,
    KeyBenefitsComponent,
    TestimonialsComponent,
    FaqComponent,
    CtaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
